import { render } from "./OverviewProductFilters.vue?vue&type=template&id=03203e7e"
import script from "./OverviewProductFilters.vue?vue&type=script&lang=js"
export * from "./OverviewProductFilters.vue?vue&type=script&lang=js"

import "./OverviewProductFilters.vue?vue&type=style&index=0&id=03203e7e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__